module.exports = __webpack_public_path__ + "img/emojione_information.fd99bebb.svg";